<template>
  <div>
    <div class="questionnaire-header">
      <div class="col-10">
        <div class="questionnaire-header-title">Argumentation</div>
      </div>
      <div class="col-2 questionnaire-header-logo"><img src="@/assets/img/logo.png"></div>
    </div>

    <div class="questionnaire-info">
      <p v-if="ifMobile" style="color:red">Nous avons détectez que vous n'êtiez pas sur un ordinateur.</p>
      <p>Nous vous recommandons d'effectuer le test depuis un ordinateur (300 mots à rédiger).</p>
      <p>Mettez-vous dans de bonnes conditions avant de commencer le test. <br>Une fois les {{ time }} minutes écoulées, vous ne pourrez plus accéder au test. </p>
    </div>

    <div class="questionnaire-section">
      <div class="questionnaire-section-header">
        <div class="questionnaire-section-header-main">Test argumentation</div>
        <div class="questionnaire-section-header-sub">{{ time }} minutes</div>
      </div>

      <div class="questionnaire-section-action">
        <div class="questionnaire-section-action-button">
          <button :disabled="isDisabled" class="btn btn-primary btn-block" @click="emit('debuter',domainId)">
            <span>Commencer le test</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import UserService from "@/services/user.service";
import RouteEnum from "@/router/RouteEnum";

const router = useRouter();
const time = ref(45);
const domainId = 4;

const ifMobile = computed(() => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
});

defineProps({
  isDisabled: Boolean
});
const emit = defineEmits(['debuter']);

onMounted(() => {
  UserService.getUserTestContent().then(
      (response) => {
        const test = response.data.argumentationecrite;
        const thirdTime = response.data.thirdtime;
        if (thirdTime) {
          time.value *= 1.33;
          time.value = Math.ceil(time.value);
        }
        if (test != null) router.push({name: RouteEnum.CANDIDACY_TESTS});
      }
  );
});
</script>
